
export default {
  name: "CrmActiveFilters",
  props: {
    filters: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    visibleFilters() {
      return this.filters.filter(
        (filter) =>
          filter &&
          filter.value !== null &&
          filter.value !== undefined &&
          filter.value !== "" &&
          filter.value !== "Todos"
      );
    },
  },
};
